import useNativeBack from '../hooks/useNativeBack';
import SheetCloseButton from './SheetCloseButton';
import { ActionButton } from './FormActions';
import { SheetRoot } from './SheetMotion';
// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/
import { Dialog } from '@headlessui/react';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/AuthContext';
import { useGroup } from '../context/GroupContext';
import { User, Wrench, Receipt, LogOut, BarChart3, HelpCircle, Clock, Trophy, ChevronRight } from 'lucide-react';
import { APP_ONBOARDING_REPLAY_EVENT } from './AppOnboarding';

const UserMenu = ({ onClose }) => {
  useNativeBack(true, onClose);
  const { user, logout } = useUser();
  const { group } = useGroup();
  const navigate = useNavigate();
  const closeRef = useRef(null);
  const sections = [
    { label: 'Activiteit', items: [
      { label: 'Afrekenen', path: '/settlements', Icon: Receipt },
      { label: 'Geschiedenis', path: '/log', Icon: Clock },
    ] },
    { label: 'Inzicht', items: [
      { label: 'Klassement', path: '/leaderboard', Icon: Trophy },
      { label: 'Groepsstatistieken', path: '/stats', Icon: BarChart3 },
    ] },
    { label: 'Instellingen', items: [
      { label: 'Profiel', path: '/profile', Icon: User },
      ...(user?.id === group?.owner_id ? [{ label: 'Groep beheren', path: '/admin', Icon: Wrench }] : []),
      { label: 'Hulp', Icon: HelpCircle, action: () => window.dispatchEvent(new Event(APP_ONBOARDING_REPLAY_EVENT)) },
    ] },
  ];

  return (
    <SheetRoot as={Dialog} open onClose={onClose} initialFocus={closeRef} className="fixed inset-0 z-[1000]">
      <div className="fixed inset-0 sheet-backdrop bg-black/60 backdrop-blur-sm" aria-hidden="true" />
      <div className="fixed inset-0 flex items-end justify-center">
        <Dialog.Panel id="user-menu-sheet" className="sheet-panel flex max-h-[85dvh] w-full flex-col rounded-t-2xl bg-white shadow-xl dark:bg-zinc-900 sm:max-w-xl">
          <div className="flex shrink-0 items-center justify-between px-5 py-3">
            <Dialog.Title className="text-lg font-bold text-zinc-900 dark:text-white">Meer</Dialog.Title>
            <SheetCloseButton ref={closeRef} onClick={onClose} label="Meer sluiten" />
          </div>
          <div className="overflow-y-auto px-2 pb-[calc(16px+env(safe-area-inset-bottom))]">
            {sections.map((section) => <section key={section.label} className="mb-3">
              <h2 className="px-4 pb-1 pt-2 text-xs font-semibold text-zinc-500 dark:text-zinc-400">{section.label}</h2>
              {section.items.map(({ label, path, Icon, action }) => (
              <button key={label} type="button" onClick={() => { onClose?.(); if (path) navigate(path); else action?.(); }} className="flex min-h-12 w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-base font-medium text-zinc-800 hover:bg-zinc-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary dark:text-white dark:hover:bg-zinc-800">
                <Icon className="h-5 w-5 shrink-0 text-zinc-500 dark:text-zinc-400" aria-hidden="true" />
                <span className="flex-1">{label}</span>
                <ChevronRight className="h-4 w-4 text-zinc-400" aria-hidden="true" />
              </button>
            ))}
            </section>)}
            <button type="button" onClick={() => { logout(); onClose?.(); }} className="mt-1 flex min-h-12 w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-base font-medium text-red-600 hover:bg-red-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-red-500 dark:text-red-400 dark:hover:bg-red-950/30">
              <LogOut className="h-5 w-5" aria-hidden="true" /> Uitloggen
            </button>
          </div>
          <div className="shrink-0 px-5 pb-[calc(16px+env(safe-area-inset-bottom))]"><ActionButton variant="secondary" onClick={onClose}>Sluiten</ActionButton></div>
        </Dialog.Panel>
      </div>
    </SheetRoot>
  );
};

export default UserMenu;
